import { PLAYER_COLORS } from "@/lib/api";

export const TILE_TABS_H = 58;

// Below the large card while a board square is being read: owner (+ floors for a building),
// the square's label, and one tab per card on the square when it holds more than one.
// Sits in the slot's reserved caption strip (TILE_TABS_H) under the card, so the card never moves.
// width: the owner line (= card width); tabsWidth: the tabs may use the free space up to the market
// and wrap onto a second row, so every label stays readable.
export default function TileCardTabs({ view, active, onPick, width, tabsWidth = width }) {
  if (!view) return null;
  const many = view.entries.length > 1;
  return (
    <div data-testid="tile-card-tabs" data-cell={view.cellKey} className="flex flex-col justify-start" style={{ width: tabsWidth, height: TILE_TABS_H - 4, marginTop: 4, gap: 3 }}>
      <div className="shrink-0 flex items-center gap-1.5 min-w-0" style={{ width, height: 14, lineHeight: "14px", fontSize: 12, fontWeight: 700, color: "var(--ink-2)" }}>
        {view.color && <span className="shrink-0" style={{ width: 9, height: 9, borderRadius: 3, background: PLAYER_COLORS[view.color] }} />}
        <span data-testid="tile-card-caption" className="truncate">{view.caption || "Sea"}</span>
        <span className="ml-auto shrink-0 font-coord" style={{ fontSize: 11, color: "var(--ink-4)" }}>{view.label || view.cellKey}</span>
      </div>
      {many && (
        <div role="tablist" aria-label="Cards on this square" className="flex flex-wrap items-center content-start min-w-0 overflow-hidden" style={{ columnGap: 4, rowGap: 3, maxHeight: 37 }}>
          {view.entries.map((e, i) => {
            const on = i === active;
            return (
              <button
                key={e.card.id}
                type="button"
                role="tab"
                aria-selected={on}
                data-testid={`tile-card-tab-${e.card.key}`}
                data-active={on ? "true" : "false"}
                title={e.broken ? `${e.label} (broken)` : e.label}
                onClick={() => onPick(i)}
                className="min-w-0 max-w-full truncate rounded-full"
                style={{
                  flex: "0 1 auto",
                  height: 17,
                  lineHeight: "15px",
                  padding: "0 7px",
                  fontSize: 10.5,
                  fontWeight: 700,
                  border: `1px solid ${on ? "var(--ink)" : "var(--line)"}`,
                  background: on ? "var(--ink)" : "var(--card)",
                  color: on ? "var(--card)" : "var(--ink-2)",
                }}
              >
                {e.label}
                {e.broken ? " · broken" : ""}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
